import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Select, Checkbox } from "antd";
import { Button, Toggle } from "@ts-digital/vrc";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomChip from "../../general/chips";
import { deadlinesScopesList } from "../../../constants/scadenze";
import SwitchView from "../../../components/deadlines/switchView";
import { Tooltip } from "antd";
import numeral from "numeral";
import { monthsList } from "../shared"; // TODO spostare in constans
import {
  FEATURE_TOGGLE_RECONCILIATION,
  FEATURE_TOGGLE_DEADLINES_MERGE,
  FEATURE_TOGGLE_TSPAY
} from "../../../config";
import {
  getFirstDateOfMonth,
  getLastDateOfMonth
} from "../../../libs/deadlinesUtils";
import { useIntl } from "react-intl";
import Header from "../header";
import "./style.css";
import DialogExportDeadlines from "../dialogExport";
import { tspayLimit } from "../../../constants/tspay";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const Option = Select.Option;

const FilterHeader = props => {
  const {    
    queryParameters,    
    dateSelected,
    onChangeDateFilter,
    customerView,
    onChangeFilter,
    selectedRows,
    setSelectedRows,
    setDialogMerge,
    setCustomersView,
    customersView,
    classifierCompanySelected,    
    mergeType,
    filterDate,
    setFilterDate,
    multiplePay,
    balanceDetailDialog,
    setBalanceDetailDialog
  } = props;

  const intl = useIntl();
  const today = new Date();
  const navigate = useNavigate();
  let amountToPay = 0;
  if (multiplePay) {
    amountToPay = `${numeral(multiplePay).format("0,0.00")} €`.replace("-", "");
  }

  const [monthsOption, setMonthsOption] = useState(null);
  const [monthSelected, setMonthSelected] = useState(null);
  const [yearsOption, setYearsOption] = useState(null);
  const [yearSelected, setYearSelected] = useState(dateSelected ? moment(dateSelected).format("YYYY") : today.getFullYear());
  const [exportCsvDialog, setExportCsvDialog] = useState(null);
  const buttonConfirmText = intl.formatMessage({
    id: "deadlines.merge.buttonConfirm"
  });
  const buttonTSPayText = intl.formatMessage({
    id: "deadlines.buttonTSPayMultiple"
  },
  { amount: multiplePay ? amountToPay : "" });
  const buttonConfirmCompensation = intl.formatMessage({
    id: "deadlines.merge.buttonConfirmCompensation"
  });
  const buttonConfirmGroup = intl.formatMessage({
    id: "deadlines.merge.buttonConfirmGroup"
  });
  const tooltipDisableButton = intl.formatMessage({
    id: "deadlines.merge.tooltipDisableButton"
  });
  const buttonCancelText = intl.formatMessage({
    id: "deadlines.merge.buttonCancel"
  });
  const [configStatus, setConfigStatus] = useState("");
  const myType = useSelector(state => state?.main?.myType);
  const tspay = useSelector(state => state.tspay);
  const servicesCompany = useSelector(state => state.servicesAgyo.allCompanyServices.status.list);
  const hasBankLinkPackage = servicesCompany?.find(app => app.appId === "EBS"); // ha almeno informative o dispositive
  
  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);
  }, [tspay]);

  useEffect(() => {
    let newMonthSelected = dateSelected
      ? moment(dateSelected).format("MMMM")
      : null;
    newMonthSelected = newMonthSelected
      ? newMonthSelected.charAt(0).toUpperCase() + newMonthSelected.slice(1)
      : today.getMonth();
    setMonthSelected(newMonthSelected);
  }, []);

  useEffect(() => {
    let monthsArray = [];
    for (let i = 0, ci = monthsList.length; i < ci; ++i) {
      const month = monthsList[i];
      monthsArray.push(<Option value={month.value} key={"month_" + month.value + i}>
        {month.text}
      </Option>);
    }
    setMonthsOption(monthsArray);
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    let yearsArray = [];
    for (let i = -3; i < 3; ++i) {
      const year = currentYear + i;
      yearsArray.push(<Option value={year} key={"year_" + year + i}>
        {year}
      </Option>);
    }
    setYearsOption(yearsArray);
  }, []);

  function onChangeMonth(value) {
    
    if (value || value === 0) {
      setMonthSelected(value);
      localStorage.setItem("monthFilterDeadlines", value);
      localStorage.setItem("calendarFromDate",
        getFirstDateOfMonth(value, yearSelected));
      localStorage.setItem("calendarToDate",
        getLastDateOfMonth(parseInt(value), yearSelected));
      onChangeDateFilter(yearSelected, value);
      let newMonthNameSel = dateSelected
        ? moment(dateSelected).format("MMMM")
        : null;
      newMonthNameSel = newMonthNameSel
        ? newMonthNameSel.charAt(0).toUpperCase() + newMonthNameSel.slice(1)
        : today.getMonth();
      setMonthSelected(newMonthNameSel);
    }
  }

  function onChangeYear(value) {
    setYearSelected(value);
    let valueMonth = monthsList.find(el => el.text === monthSelected);
    valueMonth = valueMonth ? valueMonth.value : 0;
    localStorage.setItem("yearFilterDeadlines", value);
    localStorage.setItem("calendarFromDate",
      getFirstDateOfMonth(valueMonth, value));
    localStorage.setItem("calendarToDate",
      getLastDateOfMonth(parseInt(valueMonth), parseInt(value)));
    onChangeDateFilter(value, valueMonth);
  }

  function onNextMonth() {
    let valueMonth = monthsList.find(el => el.text === monthSelected).value;
    let month = valueMonth !== 11 ? valueMonth + 1 : 0;
    let textMonth = monthsList.find(el => el.value === month).text;
    localStorage.setItem("calendarFromDate",
      getFirstDateOfMonth(month, yearSelected));
    localStorage.setItem("calendarToDate",
      getLastDateOfMonth(month, yearSelected));
    setMonthSelected(textMonth);
    localStorage.setItem("monthFilterDeadlines", month);
    if (valueMonth === 11) {
      setYearSelected((parseInt(yearSelected) + 1).toString());
      localStorage.setItem("yearFilterDeadlines",
        (parseInt(yearSelected) + 1).toString());
      localStorage.setItem("calendarFromDate",
        getFirstDateOfMonth(month, (parseInt(yearSelected) + 1).toString()));
      localStorage.setItem("calendarToDate",
        getLastDateOfMonth(month, (parseInt(yearSelected) + 1).toString()));
    }
    onChangeDateFilter(valueMonth === 11
      ? (parseInt(yearSelected) + 1).toString()
      : yearSelected,
    month);
  }

  function onPrevMonth() {
    let valueMonth = monthsList.find(el => el.text === monthSelected).value;
    let month = valueMonth !== 0 ? valueMonth - 1 : 11;
    let textMonth = monthsList.find(el => el.value === month).text;
    localStorage.setItem("calendarFromDate",
      getFirstDateOfMonth(month, yearSelected));
    localStorage.setItem("calendarToDate",
      getLastDateOfMonth(month, yearSelected));
    setMonthSelected(textMonth);
    localStorage.setItem("monthFilterDeadlines", month);
    if (valueMonth === 0) {
      setYearSelected((parseInt(yearSelected) - 1).toString());
      localStorage.setItem("yearFilterDeadlines",
        (parseInt(yearSelected) - 1).toString());
      localStorage.setItem("calendarFromDate",
        getFirstDateOfMonth(month, (parseInt(yearSelected) - 1).toString()));
      localStorage.setItem("calendarToDate",
        getLastDateOfMonth(month, (parseInt(yearSelected) - 1).toString()));
    }
    onChangeDateFilter(valueMonth === 0 ? (parseInt(yearSelected) - 1).toString() : yearSelected,
      month);
  }

  function onChange(name, value) {       

    if (onChangeFilter) {
      onChangeFilter(
        true, name, value
      );
    }
  }

  function scopesChange(value) {
    
    if (value[value.length-1] === "all") {
      onChange("scopes", ["all"]);
    } else {
      onChange("scopes", value.filter(e => e !== "all")); 
    }
  }

  const renderScopes = useCallback(() => {
    
    let items = [
      <Option value="all" label={intl.formatMessage({
        id: "generic.all"
      })} key="all">
        <div className="scopeSelectionItem">
          <span>
            <Checkbox checked={queryParameters?.scopes ? queryParameters.scopes.indexOf("all") > -1 : null} />
          </span>
          <span>
            <FormattedMessage id="generic.all" />
          </span>
        </div>
      </Option>
    ];

    for (let item in deadlinesScopesList) {
      if (deadlinesScopesList.hasOwnProperty(item)) {
        items.push(<Option
          key={"scopeOption_" + deadlinesScopesList[item]}
          value={item}
          label={deadlinesScopesList[item]}
        >
          <div className="scopeSelectionItem">
            <span>
              <Checkbox checked={queryParameters?.scopes ? queryParameters.scopes.indexOf(item) > -1 : null} />
            </span>
            <span>{deadlinesScopesList[item]}</span>
          </div>
        </Option>);
      }
    }

    return items;
  }, [queryParameters]);

  const containerClass = !customerView
    ? "filterHeader list full" +
      (queryParameters?.sameAttachmentsAs || queryParameters?.counterpartTaxId
        ? " full"
        : "")
    : "filterHeader";
  const bodyClass = !customerView
    ? "filterHeaderColumn center deadlines"
    : "filterHeaderColumn";

  const selectWidth =
    customerView &&
    (customerView === "calendar" ||
      customerView === "graph" ||
      customerView === "cashFlow")
      ? "65%"
      : "100%";
  
  return (
    <div className={containerClass}>
      <Header
        myType={myType}
        customersView={customersView}        
        datesConv={[queryParameters?.fromDate ? moment(queryParameters.fromDate, "YYYY-MM-DDTHH:mm:ss.SSS[Z]") : "", queryParameters?.toDate ? moment(queryParameters.toDate, "YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null]}
        monthSelected={monthSelected}
        yearSelected={yearSelected}
        onChangeMonth={onChangeMonth}
        onChangeYear={onChangeYear}
        onPrevMonth={onPrevMonth}
        onNextMonth={onNextMonth}
        monthsOption={monthsOption}
        yearsOption={yearsOption}
        onChange={onChange}
        filterDate={filterDate}
        setFilterDate={setFilterDate}
        balanceDetailDialog={balanceDetailDialog}
        setBalanceDetailDialog={setBalanceDetailDialog}
      />

      <div className="filterHeaderRow">
        <div
          className={bodyClass}
          style={{ marginLeft: customerView ? "20px" : 0 }}
        >
          <Select
            style={{ width: selectWidth }}
            className="scopesMultiSelect"
            dropdownClassName="scopesMultiSelectDropdown"
            mode="multiple"
            maxTagCount={3}
            size="large"
            placeholder={intl.formatMessage({
              id: "deadlines.table.allAreas"
            })}
            defaultValue={[]}
            value={queryParameters?.scopes}
            onChange={scopesChange}
            optionLabelProp="label"
          >
            {renderScopes()}
          </Select>
        </div>
        {!customerView && (
          <div className="filterHeaderColumn right deadlines">
            <div style={{ cursor: "pointer" }}>
              <CustomChip
                active={
                  !queryParameters?.["confirmed"]
                }
                onClick={e =>
                  onChange("confirmed", !queryParameters?.["confirmed"] )
                }
                description={
                  <FormattedMessage id="deadlines.table.planned" />
                }
              />
            </div>
            <div style={{ cursor: "pointer", marginRight: "20px" }}>
              <CustomChip
                active={queryParameters?.["archived"]}
                onClick={e =>
                  onChange("archived", !queryParameters?.["archived"])
                }
                description={<FormattedMessage id="deadlines.table.hidden" /> }
              />
            </div>
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                minWidth: 140,
                paddingTop: 6
              }}
            >
              <div>{<FormattedMessage id="deadlines.table.onlyHidden" /> }</div>
              <div style={{ marginLeft: "10px", paddingTop: 4 }}>
                <Toggle
                  onChange={e =>
                    onChange("expired", !queryParameters?.["expired"])
                  }
                  checked={queryParameters?.["expired"]}
                />
              </div>
            </div>
          </div>
        )}
        {customersView && (
          <div>
            <SwitchView
              customersView={customersView}
              setCustomersView={setCustomersView}
              classifierCompanySelected={classifierCompanySelected}
              myType={myType}
            />
          </div>
        )}
      </div>

      {(customersView === "list" || !customersView) &&
        FEATURE_TOGGLE_RECONCILIATION === "true" &&
        window.location.href.indexOf("/scadenzecliente") > -1 &&
        hasBankLinkPackage && (
      /* configStatus === "LINKED" &&*/ <div className="filterHeaderRow row2">
          <div>&nbsp;</div>
          <div style={{ marginRight: 20 }}>
            <Button
              kind="secondary"
              onClick={() =>
                navigate("/bank-payments")
              }
            >
              <FontAwesomeIcon
                icon={["far", "university"]}
                style={{ marginRight: 10 }}
              />
              <FormattedMessage id="deadlines.pages.table.buttonPaymentsAndCollects" />
            </Button>
          </div>
        </div>
      )}

      <div className="filterHeaderRow row2">
        {!customerView && FEATURE_TOGGLE_DEADLINES_MERGE === "true" ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              disabled={selectedRows && selectedRows.length < 2}
              onClick={() => {
                setDialogMerge(true);
                if (window.aptrinsic) {
                  if (mergeType === "compensation") {
                    window.aptrinsic("track",
                      "digital-box:DEADLINES-COMPENSATION");
                  } else {
                    window.aptrinsic("track", "digital-box:DEADLINES-GROUPING");
                  }
                }
              }}
            >
              {selectedRows.length < 2
                ? buttonConfirmText
                : mergeType === "compensation"
                  ? buttonConfirmCompensation
                  : buttonConfirmGroup}
            </Button>
            {FEATURE_TOGGLE_TSPAY === "true" &&
              myType !== "STUDIO" &&
              configStatus === "LINKED" && (
              <Tooltip
                color={"rgb(0, 80, 117)"}
                title={
                  multiplePay * -1 > tspayLimit ? (
                    <FormattedMessage
                      id={"deadlines.pages.detail.limitTipTsPayPayment"}
                      values={{
                        limit: numeral(tspayLimit).format("0,0.00") + " €"
                      }}
                    />
                  ) : (
                    ""
                  )
                }
              >
                <div>
                  <Button
                    disabled={!multiplePay || multiplePay * -1 > tspayLimit}
                    onClick={() => {
                      navigate("/tspay-payment", {state: { deadlines: selectedRows }});
                      if (window.aptrinsic) {
                        window.aptrinsic("track",
                          "digital-box:TSPAY-PAGAMASSIVO");
                      }
                    }}
                    style={{ marginLeft: 10 }}
                  >
                    {buttonTSPayText}
                  </Button>
                </div>
              </Tooltip>
            )}
            <Tooltip
              color={"rgb(0, 80, 117)"}
              placement="top"
              title={
                <>
                  {" "}
                  {tooltipDisableButton}{" "}
                  <FontAwesomeIcon
                    icon={["far", "filter"]}
                    style={{ margin: "0 4px", color: "#FFF" }}
                  />
                  .
                </>
              }
            >
              <FontAwesomeIcon
                icon={["far", "info-circle"]}
                style={{ margin: "0 16px", color: "#0090d1" }}
              />
            </Tooltip>
          </div>
        ) : null}
        <div className="deadlinesTableRightButtons">
          {(queryParameters?.counterpartDescription ||
          queryParameters?.specificDate ||
            queryParameters?.sameAttachmentsAs) && (
            <Button
              kind="tertiary"
              onClick={() => {
                
                setSelectedRows([]);
                onChangeFilter(
                  true, ["counterpartDescription", "sameAttachmentsAs", "specificDate"],
                  [null, null, null]
                );
              }}
            >
              <FontAwesomeIcon icon={["far", "times"]} /> {buttonCancelText}
            </Button>
          )}
          {(!customersView || customersView === "list") && (
            <Button
              kind="tertiary"
              onClick={() => {
                setExportCsvDialog("waiting");
              }}
            >
              <FontAwesomeIcon
                icon={["far", "file-download"]}
                style={{ marginRight: 10 }}
              />
              <FormattedMessage id="deadlines.export.csv.button" />
            </Button>
          )}
        </div>
      </div>
      {
        <DialogExportDeadlines
          mode="csv"
          status={exportCsvDialog}
          myType={myType}
          queryParameters={queryParameters}
          setStatus={setExportCsvDialog}
        />
      }
    </div>
  );
};

export default FilterHeader;
